<template>
    <div class="login-page-wrapper profile">
        <div class="over-lay"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="main-content">
                        <h3 class="heading">Live Stream Test</h3>
                    </div>
                </div>
                <div class="col-md-12 text-left">
<div style="position:relative; padding-bottom:56.25%; overflow:hidden;"><iframe title="TONE video player" src="https://content.jwplatform.com/players/a074QrQx-c398nk2E.html" width="80%" height="80%" frameborder="0" scrolling="auto" allowfullscreen style="position:absolute;"></iframe></div>
		</div>
            </div>
        </div>
    </div>
</template>

<script>
    import spinner from '@/accessibility/Spinner'
    import alert from '@/accessibility/Alert'
    import input from '@/accessibility/Input'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        name: 'login',
        data: function () {
            return {
                success: false,
                successMsg: '',
                contactForm: {
                    emailAddress: '',
                    phoneNumber: '',
                    reason: '',
                    comments: ''
                },
                spinner: false
            }
        },
        computed: {
            ...mapGetters([
                'error'
            ])
        },
        methods: {
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                    this.spinnerToggle()
                    this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(() => {
                        this.success = true
                        this.successMsg = 'Your message has been sent, we will get back to you shortly!'
                        this.spinnerToggle()
                    })
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    p strong {
        font-weight: 900;
        color: #000;
    }

    .text-left p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// LiveStreamTest.vue?eba7d8f6